import SelectOauthApp from './select-oauth-app'

export default SelectOauthApp